import React from "react";
import {Route} from "react-router-dom";

import PlanIndex from "./index";

const data = [<Route exact key="PlanIndex" path="/plan/index" element={<PlanIndex />} />];

export default data;
